/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Delayed from '@assets/delayed.svg';
import Damaged from '@assets/damaged.svg';
import Lost from '@assets/lost.svg';
import Return from '@assets/return.svg';
import { useBehaviorData } from '@hooks';

import { ClaimOption, EmailContact } from '@components';
import {
  ClaimType, ErrorCode, ClaimTypeText, ErrorCodeToSpecialText,
} from '@constants';
import {
  setClaimInfo, setDhgatePackage, clearSelectedItems, setDelayPackageId, setUploadChosen,
} from '@store';
import { getPackage } from '@api';
import { logError } from '@log';
import classes from './index.module.css';

const SUB_TITLE = 'Please tell us what happened to your order?';

const useOptionList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const setReportData = useBehaviorData();
  const {
    policyList, claimList, firstName, signature, orderNumber,
  } = useSelector((state) => state.policy);
  const claimId = claimList[0]?.claimId;

  const onClickContinue = async (type, policy, id) => {
    dispatch(setClaimInfo({ type, ...policy, id }));
    setReportData({ optionsTime: `${Date.now()}` });
    dispatch(setUploadChosen({ files: [], comments: '' }));
    // 当dhgate责任为delay时，我们只理赔一次，如果已经理赔过，直接前端到报错页面
    const delayClaimId = (claimList.find((v) => v.issueTypeCode === ClaimType.Delay && v.status !== 'Rejected')?.claimId);
    if (type === ClaimType.Delay && delayClaimId) {
      navigate('../error', { state: { code: ErrorCode.HasDelay, claimId: delayClaimId } });
      return;
    }
    try {
      const body = {
        policyId: policy.policyId,
        liabilityCode: type,
        liabilityId: id,
        path: '/gateway/claim-service/api/resolution-center/dhgate/',
        headers: { signature, 'order-id': orderNumber },
      };
      const resp = await getPackage(body);
      const { code, data } = resp;
      // console.log('ra packagedata', data);
      if (code === 0) {
        dispatch(setDhgatePackage(data));
        navigate('../choose-package');
        dispatch(clearSelectedItems());
        dispatch(setDelayPackageId());
      } else if (ErrorCodeToSpecialText.includes(code)) {
        navigate('../error', { state: { code, type } });
      } else {
        navigate('../error', { state: { code: ErrorCode.Wrong } });
      }
    } catch (e) {
      logError(e);
    }
  };

  const getItemIssue = (policy, {
    code, id, hover: hoverText,
  }) => {
    const issueMap = {
      [ClaimType.RA]: {
        count: 10,
        id: 'RA',
        icon: Return,
        title: 'I want to return the item(s)',
        onClick: () => onClickContinue(ClaimType.RA, policy, id),
      },
      [ClaimType.Theft]: {
        count: 40,
        id: 'theft',
        icon: Lost,
        title: ClaimTypeText[ClaimType.Theft],
        hoverText,
        onClick: () => onClickContinue(ClaimType.Theft, policy, id),
      },
      [ClaimType.Delay]: {
        count: 20,
        id: 'delay',
        icon: Delayed,
        title: ClaimTypeText[ClaimType.Delay],
        hoverText,
        onClick: () => onClickContinue(ClaimType.Delay, policy, id),
      },
      [ClaimType.Damage]: {
        count: 30,
        id: 'damage',
        icon: Damaged,
        title: ClaimTypeText[ClaimType.Damage],
        hoverText,
        onClick: () => onClickContinue(ClaimType.Damage, policy, id),
      },
      [ClaimType.Loss]: {
        count: 50,
        id: 'loss',
        icon: Lost,
        title: ClaimTypeText[ClaimType.Loss],
        hoverText,
        onClick: () => onClickContinue(ClaimType.Loss, policy, id),
      },
      // [ClaimType.AD]: {
      //   count: 50,
      //   id: 'ad',
      //   icon: '',
      //   title: ClaimTypeText[ClaimType.AD],
      //   onClick: () => onClickContinue(ClaimType.AD, item, id),
      // },
      // [ClaimType.EW]: {
      //   count: 60,
      //   id: 'ew',
      //   icon: '',
      //   title: ClaimTypeText[ClaimType.EW],
      //   onClick: () => onClickContinue(ClaimType.EW, item, id),
      // },
    };
    return issueMap[code];
  };
  const list = policyList.map((policy) => {
    const { liabilities = [] } = policy;
    const options = [];
    if (liabilities.length) {
      // 取接口返回liabilities
      liabilities.forEach((_) => {
        const item = getItemIssue(policy, _);
        item && options.push(item);
      });
    }
    return options.sort((a, b) => a.count - b.count);
  }).flat();

  const handleToFeedback = () => {
    navigate(`/dhgate/feedback?claimId=${claimId}`);
  };

  return {
    optionList: list, claimId, firstName, handleToFeedback,
  };
};

const Options = () => {
  const {
    optionList, firstName, claimId, handleToFeedback,
  } = useOptionList();

  return (
    <section className={classes.content}>
      <section className={classes.title}>
        Hi
        <section className={classes.customerName}>{firstName}</section>
        !
      </section>
      <section className={classes.sub_title}>{SUB_TITLE}</section>
      {optionList.map((option, index) => (
        <ClaimOption
          key={option.id + index}
          icon={option.icon}
          title={option.title}
          hoverText={option.hoverText}
          onClick={option.onClick}
        />
      ))}
      {claimId && <section className={classes.remark_link} onClick={handleToFeedback}>{'View issue history >'}</section>}
      <section className={classes.email_contact}>
        {EmailContact}
      </section>
    </section>
  );
};

export default Options;
